import React, { useEffect } from 'react';

/**
 * Closes a locally-owned popover panel on an outside click or Escape. The CRUD package
 * deliberately avoids Carbon's Menu/Popover (spec §3 #29), so every panel here is a plain
 * div — and a plain div gets none of the dismissal behaviour for free.
 */
export function useDismissPanel(open: boolean, ref: React.RefObject<HTMLElement>, onDismiss: () => void) {
  useEffect(() => {
    if (!open) {
      return;
    }
    const onPointerDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onDismiss();
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onDismiss();
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, ref, onDismiss]);
}
